// extracted by mini-css-extract-plugin
export default {"brandPromo":"NH-z","carousel":"OH-z"};